import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ScrollToTop } from './components/shared/ScrollToTop'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { createErrorHandler } from './lib/error-reporting'
import { SignInPage } from './modules/auth/SignInPage'
import { SignUpPage } from './modules/auth/SignUpPage'
import { ForgotPasswordPage } from './modules/auth/ForgotPasswordPage'
import { ResetPasswordPage } from './modules/auth/ResetPasswordPage'
import { VerifyEmailPage } from './modules/auth/VerifyEmailPage'
import { ProtectedRoute } from './components/shared/ProtectedRoute'
import { DashboardLayout } from './layouts/DashboardLayout'
import { PublicLayout } from './layouts/PublicLayout'
import { DashboardPage } from './pages/DashboardPage'
import { LandingPage } from './pages/LandingPage'
import { SettingsPage } from './modules/settings/pages/SettingsPage'
import { AdminPage } from './modules/admin/pages/AdminPage'
import { SendLetterPage } from './modules/orders/pages/SendLetterPage'
import { OrdersPage } from './modules/orders/pages/OrdersPage'
import { OrderDetailPage } from './modules/orders/pages/OrderDetailPage'
import { TemplatesPage } from './modules/templates/pages/TemplatesPage'
import { AccountPage } from './modules/credits/pages/AccountPage'
import { PrintQueuePage } from './modules/admin-orders/pages/PrintQueuePage'
import { AddressBookPage } from './modules/addresses/pages/AddressBookPage'
import { BulkSendPage } from './modules/orders/pages/BulkSendPage'

function App() {
  return (
    <ErrorBoundary onError={createErrorHandler()}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<LandingPage />} />
          </Route>

          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/sign-up" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="send/letter" element={<SendLetterPage />} />
            <Route path="send/bulk" element={<BulkSendPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<OrderDetailPage />} />
            <Route path="templates" element={<TemplatesPage />} />
            <Route path="addresses" element={<AddressBookPage />} />
            <Route path="account" element={<AccountPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="admin/print-queue" element={<PrintQueuePage />} />
            <Route path="profile" element={<Navigate to="/dashboard/settings" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
